import { render, staticRenderFns } from "./DetailsTable.vue?vue&type=template&id=7c7eeabb&scoped=true&lang=pug&"
import script from "./DetailsTable.vue?vue&type=script&lang=js&"
export * from "./DetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTable.vue?vue&type=style&index=0&id=7c7eeabb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7eeabb",
  null
  
)

export default component.exports